import styled, { css } from 'styled-components';
import { Flex } from '../../Flex';
import { FormItemStatus } from '../../Form';
import { Grid } from '../../Grid';
import { TextFieldInput } from '../../TextFieldInput';
export var DropdownContainer = styled(Flex).attrs(function () {
  return {
    flexDirection: 'column',
    backgroundColor: 'base.white',
    boxShadow: 3,
    borderRadius: 8,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'grey.base',
    minWidth: '200px'
  };
}).withConfig({
  displayName: "styled__DropdownContainer",
  componentId: "sc-1a4l9sz-0"
})(["overflow:hidden;min-height:", ";"], function (_ref) {
  var theme = _ref.theme,
      componentSize = _ref.componentSize;
  return theme.select.dropdown[componentSize].minHeight;
});
export var CustomInput = styled(TextFieldInput).withConfig({
  displayName: "styled__CustomInput",
  componentId: "sc-1a4l9sz-1"
})(["border:none;", ";"], function (_ref2) {
  var dropdownPosition = _ref2.dropdownPosition,
      theme = _ref2.theme;
  return dropdownPosition === 'bottom' ? css(["border-bottom:1px solid ", ";"], theme.colors.grey.base) : css(["border-top:1px solid ", ";"], theme.colors.grey.base);
});

var makeTriggerContainerStyle = function makeTriggerContainerStyle(_ref3) {
  var validationStatus = _ref3.validationStatus,
      theme = _ref3.theme,
      triggerSize = _ref3.triggerSize;
  return css(["height:", ";border-color:", ";"], theme.select.sizes[triggerSize].height, validationStatus === FormItemStatus.ERROR ? theme.colors.red.dark : theme.colors.grey.base);
};

var makeDisabledTriggerContainerStyle = function makeDisabledTriggerContainerStyle(_ref4) {
  var disabled = _ref4.disabled,
      theme = _ref4.theme;
  if (!disabled) return;
  return css(["pointer-events:none;background-color:", ";"], theme.colors.grey.light);
};

export var TriggerContainer = styled(Grid).attrs(function () {
  return {
    gridTemplateColumns: '1fr auto',
    alignItems: 'center',
    gridGap: 'xxs',
    borderWidth: '1px',
    borderStyle: 'solid',
    backgroundColor: 'base.white',
    cursor: 'pointer',
    borderRadius: 8,
    px: 's'
  };
}).withConfig({
  displayName: "styled__TriggerContainer",
  componentId: "sc-1a4l9sz-2"
})(["text-align:left;", " ", ""], makeTriggerContainerStyle, makeDisabledTriggerContainerStyle);
export var SelectGroupLabel = styled.div.withConfig({
  displayName: "styled__SelectGroupLabel",
  componentId: "sc-1a4l9sz-3"
})(["height:", ";"], function (_ref5) {
  var theme = _ref5.theme,
      size = _ref5.size;
  return theme.select.optionSizes[size];
});